var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('gj-table',{attrs:{"name":"storageArgs","adaptParent":"","data":_vm.tableData,"columns":_vm.columns,"loading":_vm.loading,"show-overflow":false},scopedSlots:_vm._u([{key:"content",fn:function(ref){
var row = ref.row;
return [(row.name === 'INVENTORY_UNSALABLE_ALERT')?[_c('gj-select',{attrs:{"options":[
             {id: '30', text: '30天以上库龄'},
              {id: '60', text: '60天以上库龄'},
              {id: '90', text: '90天以上库龄'},
              {id: '180', text: '180天以上库龄'},
              {id: '270', text: '270天以上库龄'},
              {id: '365', text: '365天以上库龄'}
            ],"clearable":false,"width":"200px"},on:{"input":function($event){return _vm.updateConfig($event, row)}},model:{value:(row.content),callback:function ($$v) {_vm.$set(row, "content", $$v)},expression:"row.content"}})]:_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }